module.exports = __webpack_public_path__ + "static/media/ass-report-bg.adf7e2fd.png";